import { createClient } from "@supabase/supabase-js";

export interface TenantSupabaseConfig {
  supabaseUrl: string;
  publishableKey: string;
}

export function createTenantSupabaseClient({ supabaseUrl, publishableKey }: TenantSupabaseConfig) {
  return createClient(supabaseUrl, publishableKey, {
    auth: {
      autoRefreshToken: true,
      // Invite/recovery links land with tokens in the URL hash.
      detectSessionInUrl: true,
      // Persist to sessionStorage, not localStorage: the session survives a
      // reload and is inherited by tabs opened from an in-app link (so "open
      // Edit in a new tab" no longer forces a re-login), but it is scoped to
      // the tab group and cleared once every tab closes — a fresh visit still
      // re-authenticates, keeping the tenant token off durable disk storage.
      persistSession: true,
      storage: window.sessionStorage,
    },
  });
}
